var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import VTTypography from "../VTTypography";
import VTTextField from "../VTTextField";
import HomeScenarioFilters from "./VTLandingFilters";
import React from "react";
export var VTLandingOptions = React.forwardRef(function (_a, ref) {
    var sx = _a.sx, _b = _a.title, title = _b === void 0 ? "Scenarios" : _b, _c = _a.inputPlaceholder, inputPlaceholder = _c === void 0 ? "search" : _c, filterValue = _a.filterValue, filters = _a.filters, searchValue = _a.searchValue, setSearchValue = _a.setSearchValue, sideDrawWidth = _a.sideDrawWidth, reactiveWidth = _a.reactiveWidth;
    return (_jsx(Grid, __assign({ ref: ref, container: true, xs: 12, justifyContent: "flex-end", sx: sx }, { children: _jsxs(Grid, __assign({ container: true, xs: 12, sx: {
                position: "relative",
                borderRadius: 1,
                background: "linear-gradient(to left, #0ab5a7,#8e25fa)",
                margin: 5,
                minHeight: 300,
                marginTop: "110px",
                marginLeft: sideDrawWidth / 8 + 5,
                transition: "0.5s",
            }, justifyContent: "center" }, { children: [_jsx(Grid, __assign({ item: true, container: true, xs: 12, justifyContent: "center" }, { children: _jsx(VTTypography, __assign({ sx: { margin: 2 }, type: "Heading1" }, { children: title })) })), _jsx(Grid, __assign({ item: true, container: true, xs: 12, justifyContent: "center", spacing: 2, sx: { height: "160px" } }, { children: _jsx(Grid, __assign({ item: true, container: true, xs: 12, justifyContent: "center" }, { children: _jsx(VTTextField, { placeholder: inputPlaceholder, sx: {
                                minWidth: "200px",
                                width: "60%",
                                maxWidth: "480px",
                                "& .MuiFormControl-root": {
                                    "& .MuiOutlinedInput-root": {
                                        border: "1px solid rgb(255, 255, 255, 0.7)",
                                        "&.Mui-focused fieldset": {
                                            border: "none",
                                        },
                                        "&:hover fieldset": {
                                            border: "none",
                                        },
                                    },
                                },
                            }, value: searchValue, onChange: function (e) { return setSearchValue(e); } }) })) })), filters && (_jsx(HomeScenarioFilters, { filterValue: filterValue, filters: filters, sideDrawWidth: sideDrawWidth, reactiveWidth: reactiveWidth }))] })) })));
});
